export class ShootCategory {
    id?: number;
    name?: string;
}